import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/reset.css';
import './styles/core.css';
import reportWebVitals from './reportWebVitals';
import Entry from './Entry';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Entry />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
